// Mock data for Forest Vision Alliance

export const services = [
  {
    id: 1,
    title: "Nature Interpretation Centres",
    description: "Engaging spaces for environmental education with interactive displays and immersive wildlife experiences.",
    icon: "BookOpen"
  },
  {
    id: 2,
    title: "Thematic Gateways & Sculptures",
    description: "Landmark installations promoting wildlife themes with artistic tiger, elephant, and bird sculptures.",
    icon: "Mountain"
  },
  {
    id: 3,
    title: "Eco-Tourism Infrastructure",
    description: "Sustainable huts, pathways, adventure zones, and seating areas designed for minimal environmental impact.",
    icon: "TreePine"
  },
  {
    id: 4,
    title: "Selfie Points & Photo Zones",
    description: "Instagram-worthy installations that blend wildlife sculptures with natural beauty for memorable experiences.",
    icon: "Camera"
  },
  {
    id: 5,
    title: "Sustainable Landscaping",
    description: "Eco-friendly green spaces, water features, and fountain designs that enhance natural environments.",
    icon: "Leaf"
  },
  {
    id: 6,
    title: "Artistic Installations & Murals",
    description: "Captivating art pieces for education and aesthetics, featuring wildlife and conservation themes.",
    icon: "Palette"
  }
];

export const portfolioProjects = [
  {
    id: 1,
    title: "Major Dhyan Chand Nagar Van",
    location: "Jhansi, Uttar Pradesh",
    year: "2023-24",
    category: "Urban Forest Development",
    description: "A harmonious blend of Jhansi's heritage and wildlife, featuring iconic gates dedicated to Major Dhyan Chand with architectural grandeur.",
    image: "https://customer-assets.emergentagent.com/job_forest-vision-3/artifacts/rm903abq_IMG_5564.jpg",
    galleryImages: [
      "https://customer-assets.emergentagent.com/job_forest-vision-3/artifacts/ho5gwmqb_image.jpeg",
      "https://customer-assets.emergentagent.com/job_forest-vision-3/artifacts/bhicb6r7_image.jpeg", 
      "https://customer-assets.emergentagent.com/job_forest-vision-3/artifacts/f91umea4_2e40225c-d819-4bbb-b52f-1af39d73d5c6.JPG"
    ],
    highlights: [
      "Grand entrance gate with elephant and leopard sculptures",
      "Central tiger sculpture with peacocks on either side",
      "Life-size wildlife sculptures on rocky cliff-face design",
      "Selfie points and fountains integrated into landscape",
      "Round eco-friendly huts for visitor accommodation",
      "Wildlife dioramas and educational displays",
      "Inaugurated January 29, 2024 by Principal Chief Conservator",
      "Located 12 km from Jhansi on Orchha road"
    ],
    client: "Forest Division Jhansi & Jhansi Development Authority",
    status: "Completed",
    detailedDescription: "This flagship project represents the harmonious integration of Jhansi's rich heritage with modern wildlife conservation. The iconic gate dedicated to Major Dhyan Chand stands as the first of its kind in Jhansi and Bundelkhand region, featuring a monumental archway designed to resemble a rocky cliff face with life-size sculptures of elephants at the base, leopards on ledges, and a central tiger sculpture above the arch with peacocks on either side."
  },
  {
    id: 2,
    title: "Pilibhit Tiger Reserve Projects",
    location: "Pilibhit, Uttar Pradesh", 
    year: "2023-24",
    category: "Wildlife Conservation",
    description: "Multiple projects including famous selfie points, Nature Interpretation Centers, and eco-tourism infrastructure.",
    image: "https://customer-assets.emergentagent.com/job_forest-vision-3/artifacts/rtxqtt0u_IMG_7030.png",
    galleryImages: [
      "https://customer-assets.emergentagent.com/job_forest-vision-3/artifacts/j15fm2xa_Screenshot%202024-12-14%20at%207.31.52%E2%80%AFPM.png",
      "https://customer-assets.emergentagent.com/job_forest-vision-3/artifacts/9hy7iqcy_pixelcut-export-2.png",
      "https://customer-assets.emergentagent.com/job_forest-vision-3/artifacts/73d7e8dn_updated.jpg",
      "https://customer-assets.emergentagent.com/job_forest-vision-3/artifacts/x8f0mov8_IMG_5246.png",
      "https://customer-assets.emergentagent.com/job_forest-vision-3/artifacts/2avme0r8_IMG_6129.png",
      "https://customer-assets.emergentagent.com/job_forest-vision-3/artifacts/4ud8dkg1_Screenshot%202024-12-14%20at%207.31.22%E2%80%AFPM.png",
      "https://customer-assets.emergentagent.com/job_forest-vision-3/artifacts/y4ry7mqf_PHOTO-2022-11-15-13-43-05%202.jpg",
      "https://customer-assets.emergentagent.com/job_forest-vision-3/artifacts/ctncfw31_PHOTO-2023-11-15-14-07-16.jpg",
      "https://customer-assets.emergentagent.com/job_forest-vision-3/artifacts/15ezh070_PHOTO-2022-11-09-08-15-17.jpg",
      "https://customer-assets.emergentagent.com/job_forest-vision-3/artifacts/qy48c6dt_IMG_8042.jpg"
    ],
    highlights: [
      "Most popular selfie point in Mustafabad Range",
      "Nature Interpretation Centre with artificial tree entrance",
      "3D animal sculptures in detailed dioramas",
      "Eco-friendly tents and cottages with thatched roofs",
      "Thematic gates with tiger and deer sculptures",
      "Interactive displays with touch screens for bird identification",
      "Inaugurated by Hon'ble CM Yogi Adityanath",
      "Multiple ranges: Mustafabad (35km) and Mahof (18km)"
    ],
    client: "Pilibhit Tiger Reserve",
    status: "Completed",
    detailedDescription: "Comprehensive eco-tourism development across multiple ranges featuring the famous Mustafabad selfie point with dynamic tiger and deer sculptures, Nature Interpretation Centers with immersive wildlife dioramas and artificial tree entrances, sustainable accommodation with eco-friendly tents and cottages, and educational facilities promoting tiger conservation awareness through interactive displays."
  },
  {
    id: 3,
    title: "Lucknow Zoo Projects",
    location: "Lucknow, Uttar Pradesh",
    year: "2016-18", 
    category: "Urban Wildlife & Zoo Development",
    description: "Comprehensive zoo enhancement project including Butterfly Park, Nature Interpretation Centre, Selfie Points, and complete landscaping transformation.",
    image: "https://customer-assets.emergentagent.com/job_forest-vision-3/artifacts/9mnbtpes_IMG_0670.png",
    galleryImages: [
      "https://customer-assets.emergentagent.com/job_forest-vision-3/artifacts/kons7idf_IMG_0607.png",
      "https://customer-assets.emergentagent.com/job_forest-vision-3/artifacts/df5i4ukl_IMG_7650.png",
      "https://customer-assets.emergentagent.com/job_forest-vision-3/artifacts/odacjqvd_PHOTO-2025-01-11-15-30-52.jpg",
      "https://customer-assets.emergentagent.com/job_forest-vision-3/artifacts/tzl2zdvo_PHOTO-2025-01-11-15-30-54.jpg",
      "https://customer-assets.emergentagent.com/job_forest-vision-3/artifacts/w0dn6csg_PHOTO-2018-12-20-11-17-14%202.jpg"
    ],
    highlights: [
      "Butterfly Park: Uttar Pradesh's first dedicated butterfly conservation center",
      "Nature Interpretation Centre: Interactive educational displays and dioramas", 
      "Selfie Points: Strategic photo opportunities with wildlife themes",
      "Complete Landscaping: Comprehensive garden design and plant installation",
      "Artistic installations with colorful butterfly displays and educational boards",
      "Wildlife dioramas featuring local fauna and conservation messaging",
      "Modern LED information displays and interactive learning stations",
      "Visitor-friendly pathways connecting all zoo sections",
      "Multi-year project spanning 2016-2018 development phases"
    ],
    client: "Lucknow Zoo Authority",
    status: "Completed",
    detailedDescription: "This flagship urban wildlife project represents a comprehensive transformation of Lucknow Zoo through four major components: the creation of Uttar Pradesh's first Butterfly Park featuring artistic installations and live butterfly habitats, a state-of-the-art Nature Interpretation Centre with interactive educational displays and wildlife dioramas, strategically placed Selfie Points with wildlife themes for visitor engagement, and complete landscaping renovation including garden design, pathways, and plant installations. The multi-year initiative successfully enhanced the zoo's educational value while creating an engaging visitor experience that promotes wildlife conservation awareness among urban populations."
  },
  {
    id: 4,
    title: "Chopta Selfie Point",
    location: "Rudraprayag, Uttarakhand",
    year: "2024-25", 
    category: "Mountain Eco-Tourism",
    description: "Serene mountain selfie point integrating Himalayan wildlife sculptures with natural beauty.",
    image: "https://customer-assets.emergentagent.com/job_forest-vision-3/artifacts/476ipny0_PHOTO-2024-07-14-14-23-26.jpg",
    actualImages: [
      "Heart-shaped bench sculpture with leopard perched on arch above",
      "Musk deer sculpture at base with birds on branch elements",
      "Crescent-shaped tree arch integrated into natural mountain setting",
      "Brahma Kamal flower displays in picturesque mountain landscape"
    ],
    highlights: [
      "Leopard sculpture perched on decorative arch",
      "Musk deer sculpture at base of installation", 
      "Himalayan Monal bird installations on branches",
      "Heart-shaped bench sculpture for photo opportunities",
      "Brahma Kamal flower displays integrated naturally",
      "Crescent-shaped tree arch design element",
      "Located 209 km from Dehradun in serene mountain setting",
      "Popular spot for nature lovers and photographers"
    ],
    client: "Rudraprayag Forest Division",
    status: "Completed",
    detailedDescription: "A breathtaking mountain eco-tourism installation in the serene Chopta region, featuring artistic wildlife sculptures including a leopard perched on an arch, musk deer at the base, and Himalayan Monal birds on branches, complemented by heart-shaped bench sculpture and Brahma Kamal flower installations within a stunning crescent-shaped tree arch design."
  },
  {
    id: 5,
    title: "Rapdi Eco-Tourism Centre", 
    location: "Firozabad, Uttar Pradesh",
    year: "2023-24",
    category: "Riverside Eco-Tourism",
    description: "Sustainable retreat center along scenic riverbank with eco-friendly huts and nature-centric design.",
    image: "https://customer-assets.emergentagent.com/job_forest-vision-3/artifacts/mj2hfyhr_0A8A1936.png",
    galleryImages: [
      "https://customer-assets.emergentagent.com/job_nature-projects/artifacts/mmgu3drr_0A8A1883.JPEG",
      "https://customer-assets.emergentagent.com/job_nature-projects/artifacts/kg2e1hb6_0A8A1897.JPG",
      "https://customer-assets.emergentagent.com/job_nature-projects/artifacts/f9jdcrla_0A8A1949.JPEG",
      "https://customer-assets.emergentagent.com/job_nature-projects/artifacts/275r0fr1_0A8A1940.JPG",
      "https://customer-assets.emergentagent.com/job_nature-projects/artifacts/uav55gh4_DJI_0233.JPG"
    ],
    actualImages: [
      "Aerial view of multiple eco-friendly huts with thatched roofs along riverbank",
      "Individual sustainable huts made from natural materials with wooden accents",
      "Wooden archway entrance gate with carved motifs reading 'RAPDI ECO TOURISM CENTER'",
      "Scenic riverbank setting with pathways connecting various facilities",
      "Event photos showing inauguration with officials"
    ],
    highlights: [
      "Multiple eco-friendly huts with traditional thatched roofs",
      "Sustainable construction using locally sourced materials",
      "Thematic riverside entry gate with wooden carvings", 
      "Scenic riverbank location with natural water views",
      "Pathways connecting multiple accommodation facilities",
      "Community participation programs for local engagement",
      "Inaugurated by Hon'ble Minister Dara Singh Chauhan in 2024",
      "Located 50 km from Firozabad district headquarters"
    ],
    client: "Social Forestry Division, Firozabad", 
    status: "Completed",
    detailedDescription: "An exemplary sustainable tourism project along a scenic riverbank, featuring multiple eco-conscious huts constructed using locally sourced materials with traditional thatched roofs, nature-centric thematic entry gate with wooden carvings, comfortable riverside accommodation facilities connected by pathways, and comprehensive community engagement programs that promote both conservation and local economic development."
  },
  {
    id: 6,
    title: "Ranipur Tiger Reserve Gate",
    location: "Chitrakoot, Uttar Pradesh",
    year: "2023-24",
    category: "Tiger Conservation", 
    description: "Grand stone entrance gate with architectural design reflecting traditional craftsmanship and tiger sculptures.",
    image: "https://customer-assets.emergentagent.com/job_forest-vision-3/artifacts/j37sig7w_Ranipur%20Gate.png",
    galleryImages: [
      "https://customer-assets.emergentagent.com/job_nature-projects/artifacts/8yaz6b7r_pixelcut-export%20copy%202.jpeg",
      "https://customer-assets.emergentagent.com/job_nature-projects/artifacts/tmzreds6_pixelcut-export%20copy.jpeg"
    ],
    actualImages: [
      "Large stone-built gateway with traditional architectural style and substantial tiger sculptures",
      "Tiger sculptures positioned at corners of base and on top of pillars",
      "Rustic wooden secondary entrance with thatched roof kiosk",
      "Stone craftsmanship detail showing traditional building techniques",
      "Signage reading 'RANIPUR TIGER RESERVE CHITRAKOOT' integrated into structure"
    ],
    highlights: [
      "Large stone-built gateway with traditional architecture",
      "Substantial tiger sculptures at corners and on pillars",
      "Traditional stone craftsmanship reflecting heritage design",
      "Secondary rustic wooden entrance with thatched roof",
      "Eco-tourism promotion boards integrated into structure",
      "Multiple entrance points for different sections",
      "Located 50 km from district headquarters on Satna road",
      "Part of Uttar Pradesh Eco-Tourism development program"
    ],
    client: "Chitrakoot Forest Division",
    status: "Completed", 
    detailedDescription: "A magnificent entrance gateway showcasing traditional stone craftsmanship combined with modern conservation messaging, featuring a large stone-built structure with substantial tiger sculptures positioned at the corners of the base and on top of pillars, complemented by secondary rustic wooden entrances and informational boards promoting eco-tourism and wildlife conservation awareness."
  },
  {
    id: 7,
    title: "Ghera Richhola Wetland Project",
    location: "Ghera Richhola, Pilibhit (19 km from Pilibhit on Pilibhit-Madhotanda Road)",
    year: "2022-23",
    category: "Wetland Conservation & Eco-Tourism",
    description: "Natural wetland habitat for migratory birds transformed into a prominent eco-tourism destination with thematic gates and nature huts.",
    image: "https://customer-assets.emergentagent.com/job_nature-projects/artifacts/4u896zvb_6DC45E9E-E2C1-4E3E-87CF-4A76518CAB98.JPEG",
    galleryImages: [
      "https://customer-assets.emergentagent.com/job_nature-projects/artifacts/i6ogyeli_7e37cf21-7471-4214-b9e7-905dd5bc31ba.JPG",
      "https://customer-assets.emergentagent.com/job_nature-projects/artifacts/2vhgslin_F76EEBBB-2F51-4216-A73B-8AABC8209BB7.JPEG"
    ],
    highlights: [
      "Natural wetland habitat for migratory birds including peacocks, cranes, and herons",
      "Beautifully designed thematic entrance gate with local wildlife sculptures", 
      "Traditional thatched roof nature hut with visitor seating arrangements",
      "Brick pathways connecting visitor facilities",
      "Ecologically significant site promoting conservation awareness",
      "Successfully transformed into prominent tourist attraction",
      "Enhanced under Eco-Tourism Development Initiative",
      "Collaborative project with Social Forestry Division"
    ],
    client: "Pilibhit Forest and Wildlife Division & Social Forestry Division",
    status: "Completed",
    detailedDescription: "Ghera Richhola represents the successful transformation of a natural wetland ecosystem into a sustainable eco-tourism destination. This ecologically significant site serves as a crucial habitat for migratory birds including peacocks, cranes, and herons. The comprehensive development features a stunning thematic entrance gate adorned with artistic sculptures of local wildlife species, complemented by a visually appealing traditional thatched roof nature hut designed for both aesthetic charm and visitor comfort. The project demonstrates exemplary collaboration between conservation objectives and tourism development, contributing to both biodiversity awareness and local economic growth."
  },
  {
    id: 8,
    title: "Kumbh Mela Wildlife Exhibition",
    location: "Prayagraj, Uttar Pradesh (Ganga Banks)",
    year: "2018-19",
    category: "Educational Wildlife Exhibition",
    description: "Major wildlife conservation exhibition showcased during 2019 Kumbh Mela featuring comprehensive dioramas and educational displays about Ganga ecosystem biodiversity.",
    image: "https://customer-assets.emergentagent.com/job_nature-projects/artifacts/ixw40j37_image.jpeg",
    galleryImages: [
      "https://customer-assets.emergentagent.com/job_nature-projects/artifacts/4x2m8soc_image.png",
      "https://customer-assets.emergentagent.com/job_nature-projects/artifacts/1851h75x_image.png",
      "https://customer-assets.emergentagent.com/job_nature-projects/artifacts/dm1nozii_image.jpeg"
    ],
    highlights: [
      "Showcased during the 2019 Kumbh Mela along the sacred Ganga banks",
      "Developed under the prestigious Namami Gange initiative",
      "Life-size wildlife dioramas featuring lions, tigers, elephants, and leopards",
      "Multi-level naturalistic displays with jungle settings and water features",
      "Comprehensive educational panels about Uttar Pradesh wildlife corridors",
      "Focus on endangered Ganga aquatic species: dolphins, turtles, and gharials",
      "Interactive map displays showing state-wide biodiversity conservation areas",
      "Illuminated corridor exhibitions with detailed species information",
      "Ministerial endorsement from Dara Singh Chauhan, Forest Minister UP"
    ],
    client: "Forest Division Prayagraj & Namami Gange Initiative",
    status: "Completed",
    detailedDescription: "This landmark wildlife conservation exhibition was strategically positioned along the sacred Ganga banks during the 2019 Kumbh Mela, one of the world's largest religious gatherings. Developed under the prestigious Namami Gange initiative, the exhibition featured spectacular life-size wildlife dioramas showcasing the rich biodiversity of the Ganga ecosystem and Uttar Pradesh's wildlife corridors. The multi-level naturalistic displays included majestic lions, tigers, elephants, and leopards in carefully crafted jungle settings, complemented by comprehensive educational panels highlighting endangered aquatic species such as the Ganges Dolphin, various turtle species, and gharials. The exhibition successfully raised awareness among millions of visitors about wildlife conservation and the critical importance of protecting the Ganga's unique ecosystem, earning recognition from the highest levels of government including a personal endorsement from the State Forest Minister."
  },
  {
    id: 9,
    title: "Lakshmanpuri Ecotourism Reserve",
    location: "Awadh Forest Division, Uttar Pradesh",
    year: "2024",
    category: "Ecotourism Development",
    description: "State-of-the-art 'Eco Spot' installation featuring lifelike wildlife dioramas in naturalistic forest setting, inaugurated by Honourable PCCF Wildlife.",
    image: "https://customer-assets.emergentagent.com/job_nature-projects/artifacts/s3clzn0g_image.png",
    galleryImages: [
      "https://customer-assets.emergentagent.com/job_nature-projects/artifacts/tagk1ao3_IMG_7099.jpg"
    ],
    highlights: [
      "Spectacular 'Eco Spot' wildlife diorama with multiple species display",
      "Life-sized tiger sculpture as centerpiece in naturalistic pose",
      "Graceful deer sculpture with detailed antler work and natural coloring",
      "Beautiful crane and kingfisher birds showcasing local avian diversity",
      "Authentic forest environment with trees, rocks, and natural landscaping",
      "Professional signage with 'Lakshmanpuri Ecotourism Reserve' branding",
      "Purple flowering plants and green landscaping enhancing visual appeal",
      "Official inauguration by Honourable PCCF Wildlife in 2024",
      "Latest addition to Uttar Pradesh's ecotourism infrastructure network"
    ],
    client: "Awadh Forest Division, Government of Uttar Pradesh",
    status: "Completed",
    detailedDescription: "The Lakshmanpuri Ecotourism Reserve represents Forest Vision Alliance's latest achievement in creating immersive wildlife education experiences. This state-of-the-art 'Eco Spot' installation features a spectacular wildlife diorama showcasing the region's biodiversity through meticulously crafted life-sized sculptures including a majestic tiger as the centerpiece, elegant deer with detailed antler work, graceful crane, and colorful kingfisher, all set within an authentic forest environment complete with natural trees, rock formations, and carefully designed landscaping. The project was officially inaugurated by the Honourable Principal Chief Conservator of Forests (Wildlife) in 2024, marking another milestone in Uttar Pradesh's expanding ecotourism infrastructure. The installation serves as both an educational tool for wildlife conservation awareness and a significant attraction for visitors to the Awadh Forest Division."
  },
  {
    id: 10,
    title: "Kukrail Forest Reserve - Selfie Point & Buddha Statue",
    location: "Kukrail Forest Reserve, Lucknow, Uttar Pradesh",
    year: "2025",
    category: "Forest Recreation & Spiritual Tourism",
    description: "Stunning bamboo selfie point installation with traditional Buddha statue, inaugurated during Van Mahotsav 2025 by UP's Minister of Environment Forest and Climate Change.",
    image: "https://customer-assets.emergentagent.com/job_nature-projects/artifacts/tiasinqy_6cb7b1ea-8599-4d2e-8fe4-5034dff88f71.JPG",
    galleryImages: [
      "https://customer-assets.emergentagent.com/job_nature-projects/artifacts/u2hl08uq_c9a207a1-9307-41fc-b1d1-e1ec0d0035f2.JPG",
      "https://customer-assets.emergentagent.com/job_nature-projects/artifacts/ytbkw45k_IMG_7097.jpg",
      "https://customer-assets.emergentagent.com/job_nature-projects/artifacts/o9blo4hc_IMG_7098.jpg",
      "https://customer-assets.emergentagent.com/job_nature-projects/artifacts/0y9cj131_da723d08-c851-43b3-8be9-f29f202b8ad0.JPG",
      "https://customer-assets.emergentagent.com/job_nature-projects/artifacts/gxda9o36_IMG_7100.jpg"
    ],
    highlights: [
      "Elegant curved bamboo selfie point with 'कुकरैल' (Kukrail) signage in Devanagari script",
      "Vibrant tropical landscaping with colorful flowering garlands and lush green plants",
      "Masterfully crafted Buddha statue in traditional meditation pose (Dhyana Mudra)",
      "Professional stone/concrete sculpture work with intricate facial features and robes",
      "Official inauguration during Van Mahotsav 2025 (July 2, 2025)",
      "Inaugurated by Shri Arun Kumar Saxena, Minister of State for Environment Forest",
      "Part of week-long Tree Plantation Drive promoting environmental consciousness",
      "Combines recreational photography spot with spiritual meditation space",
      "Sustainable bamboo construction showcasing eco-friendly design principles"
    ],
    client: "Kukrail Forest Reserve, Lucknow & Government of Uttar Pradesh",
    status: "Completed",
    detailedDescription: "The Kukrail Forest Reserve project represents a beautiful fusion of recreational tourism and spiritual contemplation, featuring an elegantly designed curved bamboo selfie point adorned with vibrant tropical landscaping and the traditional 'कुकरैल' signage in Devanagari script. The centerpiece is a masterfully crafted Buddha statue in the classic meditation pose (Dhyana Mudra), demonstrating exceptional stone carving craftsmanship with intricate attention to facial features, robes, and traditional iconography. This meaningful project was officially inaugurated during Van Mahotsav on July 2, 2025, by Shri Arun Kumar Saxena, Uttar Pradesh's Minister of State for Environment Forest and Climate Change, as part of a week-long Tree Plantation Drive. The installation serves dual purposes: providing visitors with an Instagram-worthy selfie spot surrounded by lush tropical plants and colorful flowering garlands, while simultaneously offering a serene space for meditation and spiritual reflection, perfectly embodying the harmony between nature conservation, recreation, and spiritual wellness."
  },
  {
    id: 11,
    title: "Niyamatpur Forest, Barabanki",
    location: "Barabanki Forest Division, Lucknow, Uttar Pradesh",
    year: "2026",
    category: "Eco-Tourism Site",
    description: "A nature-based eco-tourism destination offering an immersive forest experience through nature trails, wildlife-inspired attractions, and outdoor learning spaces.",
    image: "/portfolio/p11-full.webp",
    galleryImages: [
      "/portfolio/p11-g1.webp",
      "/portfolio/p11-g2.webp",
      "/portfolio/p11-g3.webp",
      "/portfolio/p11-g4.webp",
      "/portfolio/p11-g5.webp"
    ],
    highlights: [
      "Forest Eco-Tourism Destination",
      "Deer & Bird-Themed Experiences",
      "Nature Trails & Forest Exploration",
      "Cycling & Adventure Activities",
      "Outdoor Learning & Interpretation",
      "Nature Conservation & Eco-Education"
    ],
    client: "Barabanki Forest Division, Government of Uttar Pradesh",
    status: "Completed",
    detailedDescription: "A nature-based eco-tourism destination in Barabanki, Uttar Pradesh, offering visitors an immersive forest experience through nature trails, wildlife-inspired attractions, outdoor learning spaces and sustainable recreation. The site promotes environmental awareness while celebrating the harmony between forests, birds, wildlife and people."
  }
];

export const companies = [
  {
    id: 1,
    name: "YASH ENTERPRISES",
    specialization: "Developments, Supply & Designs",
    description: "Leading provider of comprehensive development solutions with expertise in supply chain management and innovative design concepts.",
    expertise: ["Infrastructure Development", "Material Supply", "Design Consultation", "Project Management"]
  },
  {
    id: 2,
    name: "DIAMOND ENTERPRISE",
    specialization: "Park Development & Gate Designs",
    description: "Specialized in creating stunning park developments and signature gate designs that blend functionality with artistic appeal.",
    expertise: ["Park Planning", "Gate Architecture", "Landscape Design", "Consultancy Services"]
  },
  {
    id: 3,
    name: "THE NEW Wizarts Studios",
    specialization: "Sculptures & Artistic Designs",
    description: "Creative studio focused on wildlife sculptures, park developments, and artistic installations that inspire conservation.",
    expertise: ["3D Sculptures", "Wildlife Art", "Park Development", "Artistic Installations"]
  },
  {
    id: 4,
    name: "GREEN MUSE ENTERPRISES",
    specialization: "Eco-Friendly Infrastructure",
    description: "Innovative solutions for sustainable parks, eco-friendly gates, and environmentally conscious infrastructure development.",
    expertise: ["Sustainable Design", "Eco Infrastructure", "Green Solutions", "Environmental Planning"]
  }
];

export const sustainabilityFeatures = [
  {
    id: 1,
    title: "Eco-Friendly Materials",
    description: "Using locally sourced, sustainable materials that minimize carbon footprint and support local communities.",
    impact: "50% reduction in carbon emissions"
  },
  {
    id: 2,
    title: "Wildlife Conservation",
    description: "Every project incorporates wildlife education and conservation awareness through interactive displays and art.",
    impact: "15+ species highlighted"
  },
  {
    id: 3,
    title: "Community Engagement",
    description: "Involving local communities in project development and creating sustainable employment opportunities.",
    impact: "100+ local jobs created"
  },
  {
    id: 4,
    title: "Renewable Resources",
    description: "Implementing renewable energy solutions and water conservation systems in all infrastructure projects.",
    impact: "30% energy savings"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Shri MP Gautam",
    position: "Divisional Forest Officer",
    organization: "Jhansi Forest Department",
    quote: "Forest Vision Alliance has transformed our eco-tourism infrastructure with their innovative designs and sustainable approach. Their work at Pilibhit Tiger Reserve has become a model for other reserves.",
    project: "Pilibhit Tiger Reserve"
  },
  {
    id: 2,
    name: "Shri Dara Singh Chauhan",
    position: "Minister for Forest and Wildlife",
    organization: "Government of Uttar Pradesh",
    quote: "The Butterfly Park and interpretation centers created by Forest Vision Alliance have significantly enhanced visitor experience while promoting conservation awareness.",
    project: "Lucknow Zoo Projects"
  }
];

export const contactInfo = {
  email: "forestvisionalliance@gmail.com",
  phones: ["+91 7838754906", "+91 9455376069"],
  address: "India",
  tagline: "Where Nature Meets Innovation"
};